import styled from "styled-components";

export const LotterDisplayContent = styled.div`
  max-width: 960px;
  margin: 0 auto;

  .carousel .control-arrow {
    background: rgba(12, 21, 56, 0.4);
    border-radius: 50%;
    width: 44px;
    height: 44px;
    top: 50%;
    transform: translateY(-50%);
    margin: 0 10px;
    opacity: 0.8;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background: #2806f9;
      opacity: 1;
    }

    @media screen and (max-width: 640px) {
      width: 32px;
      height: 32px;
      margin: 0 2px;
    }
  }

  .carousel .control-dots {
    bottom: -35px;

    .dot {
      background: #cbd5e1;
      box-shadow: none;
      width: 10px;
      height: 10px;

      &.selected {
        background: #2806f9;
        width: 24px;
        border-radius: 10px;
      }
    }
  }

  .carousel_radius {
    padding-bottom: 40px;
  }
`;

export const TestimonialCard = styled.div`
  background: #f8fafd;
  border-radius: 20px;
  border: 1.5px solid #e2e8f5;
  box-shadow: 0 10px 30px rgba(12, 21, 56, 0.06);
  display: flex;
  align-items: center;
  gap: 36px;
  padding: 36px 40px;
  text-align: left;
  margin: 10px 14px;

  @media screen and (max-width: 800px) {
    flex-direction: column;
    padding: 24px 20px;
    gap: 20px;
    text-align: center;
  }

  @media screen and (max-width: 500px) {
    padding: 20px 14px;
    margin: 8px 2px;
    border-radius: 16px;
  }

  .review-photo-col {
    position: relative;
    flex-shrink: 0;
    width: 200px;
    height: 220px;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);

    @media screen and (max-width: 800px) {
      width: 160px;
      height: 180px;
      margin: 0 auto;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }

    .verified-badge {
      position: absolute;
      bottom: 8px;
      left: 8px;
      right: 8px;
      background: rgba(12, 21, 56, 0.9);
      backdrop-filter: blur(4px);
      color: #ffffff;
      font-size: 10px;
      font-weight: 700;
      padding: 4px 6px;
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 4px;
      white-space: nowrap;

      svg {
        color: #2806f9;
      }
    }
  }

  .review-content-col {
    display: flex;
    flex-direction: column;
    gap: 14px;
    flex-grow: 1;

    .stars-row {
      display: flex;
      align-items: center;
      gap: 4px;

      @media screen and (max-width: 800px) {
        justify-content: center;
      }

      .star-icon {
        color: #ffb800;
        font-size: 16px;
      }

      .rating-label {
        font-size: 12px;
        font-weight: 700;
        color: #2806f9;
        margin-left: 8px;
        background: rgba(40, 6, 249, 0.08);
        padding: 3px 8px;
        border-radius: 12px;
      }
    }

    .quote-body {
      position: relative;

      .quote-mark {
        color: rgba(40, 6, 249, 0.15);
        font-size: 28px;
        margin-bottom: 6px;
        display: block;

        @media screen and (max-width: 800px) {
          margin: 0 auto 6px auto;
        }
      }

      p {
        font-size: 16px;
        line-height: 1.6;
        color: #1a233d;
        font-style: italic;
        margin: 0;

        @media screen and (max-width: 600px) {
          font-size: 14px;
        }
      }
    }

    .author-info {
      border-top: 1px solid #e8eef8;
      padding-top: 12px;
      margin-top: 4px;

      .author-name {
        font-size: 16px;
        font-weight: 800;
        color: #0c1538;
        margin-bottom: 2px;
      }

      .store-name {
        font-size: 13.5px;
        font-weight: 600;
        color: #65718d;
        margin: 0;

        .location {
          color: #2806f9;
          font-weight: 700;
        }
      }
    }
  }
`;
